import {
  Badge,
  Box,
  Button,
  Flex,
  SimpleGrid,
  Stack,
  Text,
} from "@chakra-ui/react";
import { EventIndexDto } from "./types";
import { Props } from "./types";
import { MailSendLine } from "@/components/icons/sendInvitation";
import { useNavigate } from "react-router-dom";

type DesktopProps = {
  events: EventIndexDto[];
  page: number;
  lastPage: number;
  setPage: (page: number) => void;
} & Props;

export const DesktopContent = ({ events }: DesktopProps) => {
  const navigate = useNavigate();

  const formatedDate = (value?: string | Date) => {
    return value
      ? new Date(value).toLocaleString("pt-BR", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        })
      : "";
  };

  const getDay = (date?: string | Date) =>
    date ? new Date(date).getDate() : "";
  const getMonth = (date?: string | Date) =>
    date
      ? new Date(date).toLocaleString("pt-BR", { month: "short" }).toUpperCase()
      : "";
  const getTime = (date?: string | Date) =>
    date
      ? new Date(date).toLocaleTimeString("pt-BR", {
          hour: "2-digit",
          minute: "2-digit",
        })
      : "";

  return (
    <Stack h="100%" w="100%" p={5} spacing={6}>
      <SimpleGrid columns={2} spacing={10}>
        {Array.isArray(events) &&
          events.map((event) => (
            <Box
              key={event.id}
              borderRadius="20px"
              overflow="hidden"
              boxShadow="lg"
              border="1px solid"
              borderColor="gray.200"
              bg="white"
            >
              <Box
                position="relative"
                h="240px"
                backgroundImage={
                  event.bannerMediaUrl
                    ? `linear-gradient(to bottom, rgba(0,0,0,0.1), rgba(0,0,0,0.8)), url(${event.bannerMediaUrl})`
                    : `linear-gradient(to bottom, #222, #000)` // Um leve degradê cinza para o preto caso não tenha foto
                }
                backgroundSize="cover"
                backgroundPosition="center"
                p={4}
                display="flex"
                flexDirection="column"
                justifyContent="space-between"
                borderBottomWidth="2px"
                borderBottomColor="secondary.500"
              >
                <Flex justify="space-between" align="start">
                  <Badge
                    bg="rgba(255,255,255,0.2)"
                    color="white"
                    borderRadius="full"
                    px={3}
                    variant="subtle"
                    textTransform="uppercase"
                    fontSize="xs"
                  >
                    {event.typeName}
                  </Badge>
                  <Box
                    bg="rgba(0,0,0,0.6)"
                    backdropFilter="blur(4px)"
                    border="1px solid"
                    borderColor="secondary.500"
                    color="white"
                    p={2}
                    borderRadius="xl"
                    textAlign="center"
                    minW="60px"
                  >
                    <Text fontSize="xl" fontWeight="bold" lineHeight="1">
                      {getDay(event.date)}
                    </Text>
                    <Text fontSize="xs" color="secondary.500" fontWeight="bold">
                      {getMonth(event.date)}
                    </Text>
                    <Text fontSize="xs" opacity="0.8">
                      {getTime(event.date)}
                    </Text>
                  </Box>
                </Flex>
                <Text color="white" fontSize="xl" fontWeight="bold">
                  {event.eventName}
                </Text>
              </Box>
              <Stack p={4} spacing={3} fontSize="sm" fontWeight="medium">
                <Flex justify="space-between">
                  <Text color="gray.500">LOCAL</Text>
                  <Text textAlign="right">{event.local}</Text>
                </Flex>

                <Flex justify="space-between">
                  <Text color="gray.500">RET. INÍCIO</Text>
                  <Text>{formatedDate(event.pickupInitialDate)}</Text>
                </Flex>

                <Flex
                  justify="space-between"
                  borderBottom="1px solid"
                  borderColor="gray.100"
                  pb={3}
                >
                  <Text color="gray.500">RET. FIM</Text>
                  <Text>{formatedDate(event.pickupFinalDate)}</Text>
                </Flex>
                <Flex justify="space-between" align="center" pt={2}>
                  <Badge
                    colorScheme={
                      event.statusId === 1
                        ? "green"
                        : event.statusId === 2
                        ? "red"
                        : event.statusId === 3
                        ? "orange"
                        : "green"
                    }
                    variant="subtle"
                    borderRadius="full"
                    px={4}
                  >
                    ●
                    {event.statusId === 1
                      ? "Aberto"
                      : event.statusId === 2
                      ? "Cancelado"
                      : event.statusId === 3
                      ? "Concluído"
                      : "Aberto"}
                  </Badge>

                  <Button
                    leftIcon={<MailSendLine />}
                    bg="secondary.500"
                    color="white"
                    _hover={{ bg: "secondary.300" }}
                    size="md"
                    borderRadius="xl"
                    onClick={() =>
                      navigate(`/distribuicao-convites/${event.id}`)
                    }
                  >
                    Convites
                  </Button>
                </Flex>
              </Stack>
            </Box>
          ))}
      </SimpleGrid>
    </Stack>
  );
};
